import { onPageDomain } from './page-domain';

// Hosts below are the canonical ones; onPageDomain moves them onto the page's own
// base domain at runtime (.it <-> .io, D29) - see page-domain.ts.
export const environment = onPageDomain({
  apiUrl: 'https://api-staging.realguest.it',
  appUrl: '',
  massMailingUrl: '',
  assetsBucketUrl: 'https://cdn-staging.realguest.it',
  clientUrl: 'https://checkin-staging.realguest.it',
  enableDebug: true,
  // AppSync real-time check-in. Still false: flip to true (and redeploy the API
  // Lambda so Phase B's lastCheckInData is live) to validate the GraphQL path on
  // staging before switching prod. The endpoint is the staging AppSync's custom
  // domain (same API as the raw *.appsync-api URL, which
  // infrastructure/scripts/validate-appsync.mjs validated end-to-end incl. WS
  // subscriptions); being on a base domain, it follows the page's domain (D29).
  useAppSync: true,
  appSync: {
    endpoint: 'https://appsync-staging.realguest.it/graphql',
    region: 'eu-south-1',
  },
});
